import { MessageCircle, ExternalLink } from "lucide-react";
import MotoGamingSection from "@/components/MotoGamingSection";

const DISCORD_URL = "https://discord.gg/nQKVtqFMsv";

export default function PassionsPage() {
  return (
    <>
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <span className="em-eyebrow">Passions & communauté</span>
            <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
              Se changer les idées, ensemble.
            </h1>
            <p className="mt-4 text-slate-300 max-w-2xl">
              La passion sauve des soirées. Partage ta bécane, propose une session de jeu, viens
              discuter sur Discord — peu importe le niveau, peu importe le jeu.
            </p>
          </div>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="passions-discord"
            className="inline-flex items-center gap-2 bg-indigo-500 hover:bg-indigo-600 text-white font-semibold px-5 py-3 rounded-full shadow-lg shadow-indigo-500/20"
          >
            <MessageCircle className="w-4 h-4" />
            Rejoindre le Discord
            <ExternalLink className="w-3.5 h-3.5 opacity-80" />
          </a>
        </div>
      </section>

      <MotoGamingSection />
    </>
  );
}
